/*!jslint
  this
*/
jQuery(function ($) {
  "use strict";
  var windowWidth = $(window).outerWidth();

  var isMobile = false;
  var isMobileLarge = false;
  if (windowWidth < 768) {
    isMobile = true;
  }
  if (windowWidth < 992) {
    isMobileLarge = true;
  }


  $(function () {
    AOS.init({
      easing: 'ease-in-out-sine',
      duration: 400,
      once: true
    });
  });
  $(document).on('click', '.nav-toggle', function (e) {
    $(this).toggleClass('on');
    $('html').toggleClass('nav-open');
  });

  $('.testimonial-cl').slick({
    dots: false,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow: '<div class="slick-custom-arrow slick-custom-arrow-left"></div>',
    nextArrow: '<div class="slick-custom-arrow slick-custom-arrow-right"></div>',
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      },
    ]
  });

  $('.sl-icon-lt').on('click', function (event) {
    $('.testimonial-cl').slick('slickPrev');
  });
  $('.sl-icon-rt').on('click', function (event) {
    $('.testimonial-cl').slick('slickNext');
  });


  $(".feature-cl").slick({
    autoplay: true,
    dots: true,
    arrows: false,
    autoplaySpeed: 4000,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    customPaging: function (slider, i) {
      var text = $(slider.$slides[i]).find('.feature-dtls-cnt').data('title');
      return '<a>' + text + '</a>';
    },
  });
  $(".parallax-abt,.parallax-finacs").on('mousemove', function (e) {
    var w = $(window).width();
    var h = $(window).height();
    var offsetX = 0.5 - e.pageX / w;
    var offsetY = 0.5 - e.pageY / h;

    $(".parallax").each(function (i, el) {
      var offset = parseInt($(el).data('offset'));
      var translate = "translate3d(" + Math.round(offsetX * offset) + "px," + Math.round(offsetY * offset) + "px, 0px)";

      $(el).css({
        '-webkit-transform': translate,
        'transform': translate,
        'moz-transform': translate
      });
    });
  });
  $(document).on('click', '.qustn-list-tab-head', function (e) {
    $('.qustn-list-tab').removeClass('active');
    $('.qustn-list-tab-cnt').slideUp('normal');
    if ($(this).next().is(':hidden') == true) {
      $(this).parent().addClass('active');
      $(this).next().slideDown('normal');
    }
  });

  $(document).on("click", ".tab-items-up", function (e) {
    e.preventDefault();
    var href = $(this).attr("data-class");
    console.log(href);
    $('.tab-items-up').removeClass('active');
    $(this).addClass('active');
    $('.tab-content-item').hide();
    console.log("." + href);
    $("." + href).show();
  });


  $('.post-category').click(function (e) {
    e.preventDefault();
    $('#preloader').fadeIn();
    $('.category a').removeClass('active');
    $(this).addClass('active');
    var $tgt = '#blog-container';
    var newUrl = $(this).attr('href');
    // history.pushState(null, '', newUrl);
    $("<div>").load(newUrl, function () {
      $($tgt).html($(this).find($tgt).html());
      $('#preloader').fadeOut();
    });
  });
  $('.mobile-nav li').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(e.target).toggleClass('active');

  })
  $('.mobile-nav a').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    window.location.href = $(this).attr('href');
  });



  $(window).on('resize', function () {
    onResize();
    if ($(window).outerWidth() >= 768) {
      isMobile = false;
    } else {
      isMobile = true;
    }

    if ($(window).outerWidth() >= 991) {
      isMobileLarge = false;
    } else {
      isMobileLarge = true;
    }
  });

  var activeInterval;
  function onResize() {
    var pointCounter = 1;
    $('.cmapgn-dtls-cnt li').removeClass('active')
    $('.cmapgn-dtls-cnt li').eq(0).addClass('active')
    if (!isMobile) {
      var productivityItems = $('.cmapgn-items');
      productivityItems.on('mouseover', function () {
        if (!isMobile) {
          productivityItems.removeClass('active');
          $(this).addClass('active')
        }
      })
    } else {
      if (activeInterval) {
        clearInterval(activeInterval);
        activeInterval = '';
      }
      activeInterval = setInterval(function () {
        $('.cmapgn-dtls-cnt li').removeClass('active');
        $('.cmapgn-dtls-cnt li').eq(pointCounter).addClass('active')
        if (pointCounter === ($('.cmapgn-dtls-cnt li').length - 1)) {
          pointCounter = 0;
        } else {
          pointCounter = pointCounter + 1;
        }
      }, 3000);
    }
  }
  onResize();
  var $slider = $('.insights-cl');
  $slider.on('init', function (event, slick) {
    if ($(window).width() > 768) {
      if (slick.slideCount > 3) {
        $('.whowe-insights .sl-icon-lt, .whowe-insights .sl-icon-rt').show();
      } else {
        $('.whowe-insights .sl-icon-lt, .whowe-insights .sl-icon-rt').hide();
      }
    } else if ($(window).width() <= 768) {
      if (slick.slideCount > 1) {
        $('.whowe-insights .sl-icon-lt, .whowe-insights .sl-icon-rt').show();
      } else {
        $('.whowe-insights .sl-icon-lt, .whowe-insights .sl-icon-rt').hide();
      }
    }
  });
  $slider.slick({
    dots: false,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow: '<div class="slick-custom-arrow slick-custom-arrow-left"></div>',
    nextArrow: '<div class="slick-custom-arrow slick-custom-arrow-right"></div>',
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      },
    ]
  });
  $('.whowe-insights .sl-icon-lt').on('click', function (event) {
    $('.insights-cl').slick('slickPrev');
  });
  $('.whowe-insights .sl-icon-rt').on('click', function (event) {
    $('.insights-cl').slick('slickNext');
  });
 
  $('.support-cl').slick({
    rows: 2,
    dots: false,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow: '<div class="slick-custom-arrow slick-custom-arrow-left"></div>',
    nextArrow: '<div class="slick-custom-arrow slick-custom-arrow-right"></div>',
    slidesToShow: 2,
    slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          rows: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
  $('.whowe-support .sl-icon-lt').on('click', function (event) {
    $('.support-cl').slick('slickPrev');
  });
  $('.whowe-support .sl-icon-rt').on('click', function (event) {
    $('.support-cl').slick('slickNext');
  });

  $('.explore').on('click', function (event) {
    event.preventDefault();
    let targetId = $(this).attr('href');
    let target = $(targetId);
    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top
      });
    }
  });
});






